// The check glyph in the Accepted/Selected badges (Figma "Icon_AcceptedSelected_Check").
export default function BadgeCheckIcon({
  width = 8,
  height = 6,
  fill = '#0A6B15',
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M8 0.710849L2.74325 5.96763L0 3.22434L0.71085 2.51352L2.74325 4.54589L7.28918 0L8 0.710849Z'
        fill={fill}
      />
    </svg>
  );
}
